import { ChakraProvider } from '@chakra-ui/react';
import './App.css';
import AppRoutes from './Routes';
import theme from './lib/theme/chakra.theme';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/all';
import { LanguageProvider } from './i18n/LanguageContext';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

function App() {
  return (
    <>
      <LanguageProvider>
        <ChakraProvider theme={theme}>
          <AppRoutes />
        </ChakraProvider>
      </LanguageProvider>
    </>
  );
}

export default App;
